module.exports = __webpack_public_path__ + "static/media/white-wp.c8c7f26e.svg";